import { FC } from 'react';

import { HoldingClass } from 'types';

import { formatNumber } from 'utils/formats';

type RangeByClass = {
  class: string | HoldingClass;
  from: number;
  to: number;
};

type PartnerRenumerationRangeRowProps = {
  index: number;
  range: RangeByClass;
};

const PartnerRenumerationRangeRow: FC<PartnerRenumerationRangeRowProps> = ({
  index,
  range,
}) => {
  const className = (range.class as HoldingClass)?.name || '-';
  const sharesCount = range.to - range.from + 1;

  return (
    <tr className="bg-light inner-shadow">
      <td
        key={`renumeration-range-number-${index}`}
        className="nk-tb-col text-center vertical-align-middle"
        colSpan={2}
      />

      <td
        key={`renumeration-range-type-${index}`}
        className="nk-tb-col text-center vertical-align-middle"
      >
        <div className="d-inline-flex align-items-center" />
      </td>

      <td
        key={`renumeration-range-date-${index}`}
        className="nk-tb-col text-center vertical-align-middle"
      />

      <td
        key={`renumeration-range-amount-${index}`}
        className="nk-tb-col tb-col-xl text-right vertical-align-middle"
      />

      <td
        key={`renumeration-range-premium-${index}`}
        className="nk-tb-col tb-col-xl text-right vertical-align-middle"
      />

      <td
        key={`renumeration-range-shares-${index}`}
        className="nk-tb-col text-right vertical-align-middle"
      >
        {formatNumber(sharesCount)}
      </td>

      <td
        key={`renumeration-range-class-${index}`}
        className="nk-tb-col tb-col-xl text-center vertical-align-middle flex-grow-1"
      >
        {className}
      </td>

      <td
        key={`renumeration-range-from-${index}`}
        className="nk-tb-col tb-col-xl text-right vertical-align-middle"
      >
        {formatNumber(range.from)}
      </td>

      <td
        key={`renumeration-range-to-${index}`}
        className="nk-tb-col tb-col-xl text-right vertical-align-middle"
      >
        {formatNumber(range.to)}
      </td>

      <td
        key={`renumeration-range-${index}`}
        className="nk-tb-col tb-col-xl"
        colSpan={5}
      />
    </tr>
  );
};

export default PartnerRenumerationRangeRow;
